const state = {
  caseinfoPageId: {},
}

const mutations = {
  SET_CASEINFO_PAGE_ID: (state, caseinfoPageId) => {
    state.caseinfoPageId = caseinfoPageId
  },
}

const actions = {
  addCaseinfoId({ state, commit }, info) {
    // Object.assign(state.caseinfoPageId, info)
    commit('SET_CASEINFO_PAGE_ID', {...state.caseinfoPageId, ...info})
  },

  delCaseinfoId({ state, commit }, id) {
    delete state.caseinfoPageId[id]
    commit('SET_CASEINFO_PAGE_ID', state.caseinfoPageId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/caseInfoPage.js